import type { Breadcrumb, BreadcrumbHint } from '@sentry/react';

type SeverityLevel = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug';

interface SentryLike {
  captureException: (error: any, hint?: any) => void;
  addBreadcrumb: (breadcrumb: Breadcrumb, hint?: BreadcrumbHint) => void;
}

interface DatadogLike {
  addError: (error: any, context?: { extra?: any }) => void;
}

let sentryRef: SentryLike | null = null;
let datadogRef: DatadogLike | null = null;

export function _setMonitoringRefs(sentry: SentryLike | null, datadog: DatadogLike | null) {
  sentryRef = sentry;
  datadogRef = datadog;
}

export const telemetry = {
  captureError: (error: any, extra?: any, level: SeverityLevel = 'error') => {
    sentryRef?.captureException(error, { extra, level });
    datadogRef?.addError(error, { extra });
    if (level === 'error' || level === 'fatal') {
      console.error(error, extra);
    } else if (level === 'warning') {
      console.warn(error, extra);
    } else {
      console[level || 'log'](error, extra);
    }
  },
  addBreadcrumb: (breadcrumb: Breadcrumb, hint?: BreadcrumbHint) => {
    sentryRef?.addBreadcrumb(breadcrumb, hint);
  },
};
